export const RoleType = {
  staff: 'staff',
  customer: 'customer',
  grower: 'grower',
  sales_rep: 'sales_rep',
  agronomist: 'agronomist',
  guest: 'guest-svc',
};
